<template>
  <v-container grid-list-md fluid text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1">
        <v-toolbar-title>
          {{ $t('levels.levels_title') }}
        </v-toolbar-title>
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0"
          v-if="
            userPermissions[possibleUserModulePermissions.WATCH_LEVELS] &&
            (userPermissions[possibleUserModulePermissions.DOWNLOAD_LEVELS] ||
              userPermissions[possibleUserModulePermissions.UPDATE_LEVELS] ||
              userPermissions[possibleUserModulePermissions.ADD_LEVELS])
          "
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="
                    userPermissions[possibleUserModulePermissions.UPDATE_LEVELS]
                  "
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  small
                  v-on="on"
                  @click="updateDataLevel"
                >
                  <v-icon>save</v-icon>
                  <v-icon>save</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  v-model="buttonFab.fab"
                  style="z-index: 99"
                  color="gradiente"
                  dark
                  fab
                  small
                  v-on="on"
                >
                  <v-icon>more_vert</v-icon>
                  <v-icon>more_horiz</v-icon>
                </v-btn>
              </template>
              <span
                v-if="
                  userPermissions[possibleUserModulePermissions.UPDATE_LEVELS]
                "
              >
                {{ $t('levels.save_changes') }}
              </span>
              <span v-else>{{ $t('generic.more_options') }}</span>
            </v-tooltip>
          </template>
          <v-tooltip
            right
            v-if="userPermissions[possibleUserModulePermissions.ADD_LEVELS]"
          >
            <v-btn
              :disabled="flags.gAdding"
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="addLevel"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>{{ $t('levels.add_level') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadLevels"
              v-if="
                userPermissions[possibleUserModulePermissions.DOWNLOAD_LEVELS]
              "
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>{{ $t('levels.download_levels') }}</span>
          </v-tooltip>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="downloadGGs"
              v-if="
                userPermissions[possibleUserModulePermissions.DOWNLOAD_GG] &&
                selected.level.id != null
              "
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar grupos</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 76.5vh"
        class="scrollDesign"
      >
        <v-layout
          row
          wrap
          v-show="userPermissions[possibleUserModulePermissions.WATCH_LEVELS]"
        >
          <v-flex xs12 sm3 scrollDesign style="max-height: 72vh">
            <v-slide-y-transition class="two-line subheader" group tag="v-list">
              <v-subheader key="subheader" inset>
                {{ $t('levels.levels_title') }}
              </v-subheader>
              <v-list-tile
                v-for="item in levels"
                :key="item.id"
                avatar
                ripple
                :class="
                  'pa-2 mb-1' +
                  (selected.level.id == item.id
                    ? ' selectedElement'
                    : ' elevation-1 grey lighten-3')
                "
                style="border-radius: 5px"
                @click="selectLevel(item)"
              >
                <v-list-tile-avatar>
                  <v-icon :color="item.isExtra ? 'secondary' : 'primary'" large
                    >flag</v-icon
                  >
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.typeLevel }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.abbr }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-slide-y-transition>
          </v-flex>
          <v-slide-x-transition>
            <v-flex
              xs12
              sm9
              v-show="flags.lAdding || selected.level.id != null"
              :key="0"
            >
              <v-form>
                <v-tabs v-model="tabs.active" slider-color="white" grow>
                  <v-tab
                    :key="1"
                    ripple
                    :class="
                      tabs.active == 0
                        ? 'tabSelected border-gradient-sk'
                        : 'nothingBtn'
                    "
                  >
                    {{ $t('levels.general_information') }}
                  </v-tab>
                  <v-tab
                    :key="2"
                    ripple
                    :class="
                      tabs.active == 1
                        ? 'tabSelected border-gradient-sk'
                        : 'nothingBtn'
                    "
                    v-show="selected.level.id != null"
                  >
                    {{ $t('levels.doors') }}
                  </v-tab>
                  <v-tab
                    :key="3"
                    ripple
                    :class="
                      tabs.active == 2
                        ? 'tabSelected border-gradient-sk'
                        : 'nothingBtn'
                    "
                    v-show="selected.level.id != null"
                    >horario</v-tab
                  >
                  <v-tabs-items v-model="tabs.active">
                    <v-tab-item :key="1">
                      <v-container class="innerContainer">
                        <LevelsInfo
                          :lAdding="flags.lAdding"
                          :lUpdate="flags.lUpdate"
                          :lEditing="flags.lEditing"
                          :lvl="selected.level"
                          :userPermissions="userPermissions"
                          :doors="selected.doors"
                          :showRedirectToCustomHours="showRedirectToCustomHours"
                          :customScheduleHrsOptions="customScheduleHrsOptions"
                          @sUpdate="
                            flags.lUpdate = false
                            $emit('nUpdate')
                          "
                          @loading="working.loading = true"
                          @success="sAddLevel"
                          @successUpdate="updateDoors"
                          @error="processErrorLevel"
                          @flagUpdate="flags.nUpdate = true"
                          @deleted="deleted"
                          @goToCustomHours="tabs.active = 2"
                        ></LevelsInfo>
                        <LevelsGG
                          :sGrade="selected.sGrade"
                          :nGroup="nGroup"
                          :userPermissions="userPermissions"
                          :groups="selected.groups"
                          :nGrade="nGrade"
                          :grades="selected.grades"
                          :resetNew="flags.resetNew"
                          :lvl="selected.level"
                          @selectGG="selectGG"
                          v-show="selected.level.id != null"
                          @loading="working.loading = true"
                          @success="
                            working.loading = false
                            toast.success = true
                          "
                          @error="
                            working.loading = false
                            toast.failed = true
                          "
                          @succesCreate="successCreate"
                          @successCreateG="successCreateG"
                          @resetNewChange="flags.resetNew = false"
                          @reload="reload"
                        ></LevelsGG>
                      </v-container>
                    </v-tab-item>
                    <v-tab-item :key="2">
                      <v-container class="innerContainer">
                        <v-layout row wrap>
                          <v-flex xs12 scrollDesign style="max-height: 75vh">
                            <label>
                              <b>Puertas</b>
                            </label>
                            <v-layout row wrap>
                              <v-flex xs12 sm6>
                                <v-list subheader two-line>
                                  <v-list-tile
                                    v-for="door in doors"
                                    :key="door.id"
                                  >
                                    <v-list-tile-content>
                                      <v-checkbox
                                        :color="
                                          selected.level.isExtra
                                            ? 'secondary'
                                            : 'primary'
                                        "
                                        v-model="selected.doors"
                                        @change="flags.nUpdate = true"
                                        :label="door.doorName"
                                        :value="door"
                                        :disabled="
                                          userPermissions[
                                            possibleUserModulePermissions
                                              .UPDATE_LEVELS
                                          ]
                                            ? false
                                            : true
                                        "
                                      >
                                      </v-checkbox>
                                    </v-list-tile-content>

                                    <v-list-tile-avatar>
                                      <v-avatar
                                        :color="door.color"
                                        size="25"
                                      ></v-avatar>
                                    </v-list-tile-avatar>
                                  </v-list-tile>
                                </v-list>
                              </v-flex>
                              <v-flex xs12 sm6>
                                <GmapMap
                                  ref="mapLevels"
                                  :center="{
                                    lat:
                                      getBranch.latitude != null
                                        ? getBranch.latitude
                                        : 19.702559,
                                    lng:
                                      getBranch.longitude != null
                                        ? getBranch.longitude
                                        : -101.192341,
                                  }"
                                  :zoom="
                                    getBranch.zoom != null ? getBranch.zoom : 20
                                  "
                                  style="height: 400px; margin-top: 3px"
                                  :options="mapConfig"
                                >
                                  <GmapMarker
                                    :position="{
                                      lat:
                                        getBranch.markLatitude != null
                                          ? getBranch.markLatitude
                                          : 19.702559,
                                      lng:
                                        getBranch.markLongitude != null
                                          ? getBranch.markLongitude
                                          : -101.192341,
                                    }"
                                    :icon="google && markerBranchIcon"
                                  />
                                  <GmapMarker
                                    :key="m.id"
                                    v-for="(m, index) in doors"
                                    :position="{
                                      lat: m.latitude,
                                      lng: m.longitude,
                                    }"
                                    v-if="includes(m)"
                                    :title="m.doorName"
                                    :label="m.doorName"
                                    :icon="markerDoorIcon"
                                  />
                                </GmapMap>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-tab-item>
                    <v-tab-item :key="3">
                      <LevelsSchedule
                        @onCustomHoursPerDay="onCustomHoursPerDay"
                        @onCustomTolerance="onCustomTolerance"
                        @onCustomSwitch="onCustomSwitch"
                        @isCustomHoursPerDayOutings="
                          onIsCustomHoursPerDayOutings
                        "
                        @onIsValidCustomHoursPerDay="onIsValidCustomHoursPerDay"
                        @checkTimeIn="onCheckTimeIn"
                        @sendTolerance="sendTolerance"
                        @invalidScheduleDates="onInvalidScheduleDates"
                        :levelInfo="selected.level"
                        :invalidScheduleDates="invalidDates"
                        :userPermissions="userPermissions"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-form>
            </v-flex>
          </v-slide-x-transition>
        </v-layout>
      </v-container>
    </v-layout>
    <ErrorSchedule
      v-model="showCustomScheduleError"
      :fixed="true"
      text="Ups! no pudimos guardar la configuración, es necesario que asignes un horario a cada uno de los días hábiles."
    ></ErrorSchedule>
    <alert
      v-model="toast.alert"
      title="Alerta"
      :description="toast.message"
    ></alert>
    <loading v-model="working.loading" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-container>
</template>

<script>
import { mapSettings } from '@/Catalogs/mapSettings'
import { gmapApi } from 'vue2-google-maps'
import { mapGetters } from 'vuex'
import { funciones } from '../../../Mixins/Funciones'
import alert from '../../Dialogs/Alert'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import LevelsGG from '../../Sections/Levels/Levels-GG.vue'
import LevelsInfo from '../../Sections/Levels/Levels-Info.vue'
import LevelsSchedule from '../../Sections/Levels/Levels-Schedule.vue'

import { _getUserPermissions } from '../../../utils/genericUtils.js'
import ErrorSchedule from '../../Dialogs/Error.vue'

export default {
  mixins: [funciones],
  components: {
    loading,
    success,
    error,
    LevelsInfo,
    LevelsGG,
    LevelsSchedule,
    alert,
    ErrorSchedule,
  },
  props: ['nUpdateResponse'],
  watch: {
    nUpdateResponse() {
      if (this.nUpdateResponse) {
        this.updateDataLevel()
      }
    },
    getBranch() {
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_LEVELS] &&
        !this.levels.length > 0
      ) {
        this.getLevels()
        this.getLevelTools()
        this.$forceUpdate()
        var v = this
        this.$refs.mapLevels.$mapPromise.then((map) => {
          map.setZoom(v.getBranch.zoom != null ? v.getBranch.zoom : 17)
        })
      }
    },
    getUser() {
      this.mapPermits()
      if (
        this.userPermissions[this.possibleUserModulePermissions.WATCH_LEVELS] &&
        !this.levels.length > 0 &&
        this.getBranch.id
      ) {
        this.getLevels()
        this.getLevelTools()
        var v = this
        this.$refs.mapLevels.$mapPromise.then((map) => {
          map.setZoom(v.getBranch.zoom != null ? v.getBranch.zoom : 17)
        })
        this.$forceUpdate()
      }
    },
    'flags.nUpdate'() {
      this.$emit('flagUpdate')
    },
  },
  data: () => ({
    invalidScheduleDates: [],
    invalidDates: {},
    checkTimeIn: false,
    showCustomScheduleError: false,
    customScheduleHrsOptions: {
      customSchedule: false,
      minutesLate: '',
      scheduleDays: [
        {
          dayOfWeek: 1,
          startTime: '08:00:00',
          endTime: '18:00:00',
        },
      ],
    },
    showRedirectToCustomHours: false,
    tabs: {
      active: 0,
    },
    buttonFab: {
      fab: false,
      hidden: false,
    },
    levels: [],
    doors: [],
    working: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
      alert: false,
      message: '',
    },
    selected: {
      level: {},
      doors: [],
      grades: [],
      groups: [],
      sGrade: {},
      eGrade: {},
      eGroup: {},
    },
    flags: {
      gAdding: false,
      lAdding: false,
      lEditing: false,
      gEditing: false,
      resetNew: false,
      lUpdate: false,
      nUpdate: false,
    },
    nGrade: [],
    nGroup: [],
    userPermissions: {},
    possibleUserModulePermissions: {
      //  GRADE GROUPS
      ADD_GG: 'ADD_GG',
      UPDATE_GG: 'UPDATE_GG',
      DELETE_GG: 'DELETE_GG',
      DOWNLOAD_GG: 'DOWNLOAD_GG',
      //  LEVELS
      WATCH_LEVELS: 'WATCH_LEVELS',
      ADD_LEVELS: 'ADD_LEVELS',
      UPDATE_LEVELS: 'UPDATE_LEVELS',
      DOWNLOAD_LEVELS: 'DOWNLOAD_LEVELS',
      DELETE_LEVELS: 'DELETE_LEVELS',
      //  DOORS
      ADD_DOORS: 'ADD_DOORS',
      DELETE_DOORS: 'DELETE_DOORS',
      DOWNLOAD_DOORS: 'DOWNLOAD_DOORS',
    },
    _maxFlowConfigTries: 4,
    _flowConfigTries: 0,
  }),
  mounted() {
    if (this.getUser.id) this.mapPermits()
    if (
      this.getBranch.id &&
      this.userPermissions['WATCH_LEVELS'] &&
      !this.levels.length > 0
    ) {
      this.getLevels()
      this.getLevelTools()
      var v = this
      this.$refs.mapLevels.$mapPromise.then((map) => {
        map.setZoom(v.getBranch.zoom != null ? v.getBranch.zoom : 17)
      })
    }
    this._configFlow()
  },
  methods: {
    _configFlow() {
      if (
        this.$route.name !== 'LevelsConfig' ||
        this._flowConfigTries >= this._maxFlowConfigTries
      ) {
        return
      }

      if (this.levels.length === 0) {
        const timeEachTryInMs = 1000
        this._maxFlowConfigTries++

        const tempTime = setTimeout(() => {
          this._configFlow()
          clearTimeout(tempTime)
        }, timeEachTryInMs)
        return
      }
      const level = 0
      const section = 2

      this.selectLevel(this.levels[level])
      this.tabs.active = parseInt(section)
    },
    onCustomHoursPerDay(e) {
      // console.log(structuredClone(e))
      // NECESSARY FOR EXTRA LEVELS
      const removedEmptyDays = structuredClone(e).filter((e) =>
        e.startTime === null && e.endTime === null ? false : true
      )
      // console.log(removedEmptyDays)
      this.customScheduleHrsOptions = {
        ...this.customScheduleHrsOptions,
        scheduleDays: removedEmptyDays,
      }
    },
    onCustomTolerance(e) {
      // console.log(e)
      this.customScheduleHrsOptions = {
        ...this.customScheduleHrsOptions,
        minutesLate: e,
      }
    },
    onCustomSwitch(e) {
      // this.customScheduleHrsOptions = { ...this.customScheduleHrsOptions, customSchedule: e, };
    },
    onCheckTimeIn(e) {
      this.checkTimeIn = e
    },
    onIsValidCustomHoursPerDay(e) {
      this.customScheduleHrsOptions = {
        ...this.customScheduleHrsOptions,
        customSchedule: e,
      }
    },

    onIsCustomHoursPerDayOutings(e) {
      this.showRedirectToCustomHours = e
    },
    mapPermits() {
      this.userPermissions = _getUserPermissions({
        getUser: this.getUser,
        possibleUserModulePermissions: this.possibleUserModulePermissions,
      })
    },
    downloadLevels() {
      this.download('niveles', this.levels)
    },
    downloadGGs() {
      this.download('grados', this.selected.grades)
    },
    getLevels() {
      this.$store
        .dispatch('level/getLevels')
        .then((response) => {
          this.levels = response.data.entity.levels
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    selectLevel(lvl) {
      this.showCustomScheduleError = false
      this.selected.sGrade = { groups: [] }
      this.selected.groups = []
      this.selected.level = lvl
      this.flags.lAdding = false
      this.flags.lEditing = true
      this.flags.gAdding = false
      this.selected.eGrade = {}
      this.flags.gEditing = false
      this.nGrade = []
      this.nGroup = []
      this.flags.resetNew = true
      this.getDoorsByLevel(lvl)
      this.getGgByLevel(lvl)
    },
    selectGG(event) {
      this.selected.sGrade = event
      this.nGrade = []
      this.nGroup = []
    },
    addLevel() {
      this.flags.lEditing = false
      this.flags.lAdding = true
      this.selected = {
        level: {
          departureTime: '12:00:00',
        },
        doors: [],
        grades: [],
        groups: [],
        sGrade: {},
      }
    },
    sAddLevel() {
      this.working.loading = false
      this.toast.success = true
      this.flags.lAdding = false
      this.getLevels()
    },
    getLevelTools() {
      this.$store
        .dispatch('level/getLevelsTools')
        .then((response) => {
          this.doors = response.data.entity.doors
          this.$forceUpdate()
        })
        .catch((error) => {})
    },
    getDoorsByLevel(lvl) {
      this.$store
        .dispatch('doors/getDoorsByLevel', lvl.id)
        .then((response) => {
          this.selected.doors = response.data.entity.groupd.doors
          this.selected = {
            ...this.selected,
            level: {
              ...this.selected.level,
              customSchedule: response.data.entity.customSchedule,
              scheduleDays: response.data.entity.scheduleDays,
              minutesLate: response.data.entity.minutesLate,
              customSchedule: response.data.entity.customSchedule,
            },
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getGgByLevel(lvl) {
      this.$store
        .dispatch('level/getGgByLevel', lvl.id)
        .then((response) => {
          this.selected.grades = response.data.entity.grades
          this.$forceUpdate()
        })
        .catch((error) => {
          this.selected.grades = []
        })
    },
    deleted() {
      this.selected.sGrade = { groups: [] }
      this.selected.groups = []
      this.selected.level = {}
      this.flags.lAdding = false
      this.flags.gAdding = false
      this.selected.eGrade = {}
      this.flags.gEditing = false
      this.nGrade = []
      this.nGroup = []
      this.flags.resetNew = true
    },
    processErrorLevel(code) {
      this.working.loading = false
      if (code != null && code == 400) {
        this.toast.message =
          'El nivel no es posible eliminarlo debido a que hay alumnos inscritos en él. Elimine los alumnos del nivel para poder eliminarlo con éxito'
        this.toast.alert = true
      } else if (code != null && code == 1128) {
        this.toast.message = 'Debes añadir por lo menos una puerta'
        this.toast.alert = true
      } else {
        this.toast.failed = true
      }
    },
    includes(m) {
      for (var d in this.selected.doors) {
        if (this.selected.doors[d].id == m.id) {
          return true
        }
      }
      return false
    },
    successCreate(event) {
      this.working.loading = false
      this.toast.success = true
      var gg = {
        name: event.data[0].entity.grade,
        groups: [
          {
            id: event.data[0].entity.id,
            name: event.data[0].entity.group,
          },
        ],
        totalByGrade: 0,
      }
      this.selected.grades.push(gg)
      this.selected.groups.push({
        id: event.data[0].entity.id,
        name: event.data[0].entity.group,
      })
      this.$forceUpdate()
    },
    successCreateG(event) {
      // console.log(event);
      this.working.loading = false
      this.toast.success = true
      this.$forceUpdate()
    },
    reload() {
      this.selectLevel(this.selected.level)
    },
    onInvalidScheduleDates(e) {
      this.invalidScheduleDates = e
    },
    /**
     * @returns {[invalidScheduleDates:{}, someInvalidDate:Boolean]}
     */
    _getInvalidDates() {
      const invalidScheduleDates = {}
      if (this.invalidScheduleDates.length === 0) {
        return [invalidScheduleDates, false]
      }

      for (const date of this.invalidScheduleDates) {
        invalidScheduleDates[date.dayOfWeek] = {}
        invalidScheduleDates[date.dayOfWeek].in =
          date.startTime === null && this.checkTimeIn
        invalidScheduleDates[date.dayOfWeek].out = date.endTime === null
      }

      const someInvalidDate = Object.values(invalidScheduleDates)
        .map((e) => e.in === false && e.out === false)
        .some((e) => e === false)
      return [invalidScheduleDates, someInvalidDate]
    },
    updateDataLevel() {
      let someInvalidDate
      ;[this.invalidDates, someInvalidDate] = this._getInvalidDates()

      if (someInvalidDate) {
        this.showCustomScheduleError = true
        return
      }

      this.showCustomScheduleError = false
      this.flags.lUpdate = true
    },
    updateDoors() {
      // this.$store
      //   .dispatch("doors/updateDoorsLevel", {
      //     id: this.selected.level.id,
      //     data: { entity: this.selected.doors }
      //   })
      //   .then(response => {
      this.working.loading = false
      this.toast.success = true
      //     })
      //     .catch(error => {
      //       console.log(error);
      //       this.working.loading = false;
      //       this.toast.failed = true;
      //     });
    },
  },
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings,
      }
    },
    markerDoorIcon() {
      return {
        url: require('@/assets/mapIcons/if_map-marker_3688470.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },
    markerBranchIcon() {
      return {
        url: require('@/assets/mapIcons/if_graduation-cap_3688484.png'),
        scaledSize: new google.maps.Size(48, 48),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(24, 48),
        labelOrigin: new google.maps.Point(24, 0),
      }
    },

    ...mapGetters(['getBranch', 'getUser']),
  },
}
</script>

<style>
.selectedElement {
  background-color: white;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-color: #e6e6e6 !important;
}
.innerContainer {
  border-radius: 13px;
  background-color: white;
  border-color: #e6e6e6 !important;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.tabSelected {
  background: #fff;
  border-bottom: solid;
  border-bottom-width: 5px;
  border-image-slice: 1;
}
.border-gradient-sk {
  border-image-source: linear-gradient(to left, #56306f, #ed565b);
}
.nothingBtn {
  background: #eee;
  text-decoration: underline;
}
</style>
